import React from 'react';
import { DelayMilestone, groupDelayReasonsForChart } from '@/components/entities/patient/delayReasons/delayReasons';
import DelaysBreakdown, { DelayReason } from './DelaysBreakdown';

interface PacuDelaysBreakdownProps {
  reasons: DelayReason[];
  delayType: DelayMilestone;
  /** Fixed chart height in px. When set, skips aspect-ratio sizing so wide panels stay short. */
  height?: number;
}

const PacuDelaysBreakdown = ({ reasons, delayType, height }: PacuDelaysBreakdownProps) => {
  return <DelaysBreakdown reasons={groupDelayReasonsForChart(reasons, delayType)} height={height} />;
};

export default PacuDelaysBreakdown;
